<div class="content-div">

  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
  </div>

  <div class="top-bar">
    <span class="page-header" [innerHTML]="pageHeading"></span>
  </div>

  <div class="edit-user-placeholder">
    <p>Edit user component for user ID: {{ userId }}</p>
  </div>

</div>
